import { render } from "./DoctorsListTemplate2.vue?vue&type=template&id=2eea0a10&scoped=true"
import script from "./DoctorsListTemplate2.vue?vue&type=script&lang=ts"
export * from "./DoctorsListTemplate2.vue?vue&type=script&lang=ts"

import "./DoctorsListTemplate2.vue?vue&type=style&index=0&id=2eea0a10&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2eea0a10"

export default script